import { render, staticRenderFns } from "./addFazhan.vue?vue&type=template&id=829b0688&scoped=true"
import script from "./addFazhan.vue?vue&type=script&lang=js"
export * from "./addFazhan.vue?vue&type=script&lang=js"
import style0 from "./addFazhan.vue?vue&type=style&index=0&id=829b0688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829b0688",
  null
  
)

export default component.exports